var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1018 13.604C13.4704 13.5272 13.6899 13.1415 13.5068 12.8126C13.103 12.0874 12.467 11.4502 11.6533 10.9646C10.6054 10.3392 9.32139 10.0002 8.0005 10.0002C6.67961 10.0002 5.39564 10.3392 4.34771 10.9646C3.53404 11.4502 2.89798 12.0874 2.49423 12.8126C2.31109 13.1415 2.5306 13.5272 2.89916 13.604C6.2639 14.3052 9.73709 14.3052 13.1018 13.604Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00053,
    cy: 5.33325,
    r: 3.33354,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e6db564da4e9191e57808a2d542a3487.svg";
export { ForwardRef as ReactComponent };